module.exports = __webpack_public_path__ + "static/media/ic_searchtype_rocks.4e0844d7.svg";